import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { DocumentsService } from '../../services/documents.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { pipe } from 'rxjs'
import { map } from 'rxjs/operators'
import * as moment from 'moment';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { FileService } from '../../../common/services/file.service';
import { FileFormatEnum } from 'app/modules/common/enums/file-format-enum';

@Component({
    selector: 'app-add-document',
    templateUrl: './add-document.component.html',
    styleUrls: ['./add-document.component.scss'],
    standalone: false
})
export class AddDocumentComponent implements OnInit {

  NewDocumentFormGroup: UntypedFormGroup;
  IsSaving: boolean = false;
  file: any;
  fileBase64Value: string;
  public documentTypes: Array<{ value: string, viewValue: string }>;
  //private allowableFileTypes: Array<string> = ['PDF', 'DOC', 'JPG', 'PNG', 'BMP', 'TIF'];
  public FileFormatEnum = FileFormatEnum;

  constructor(
    public fb: UntypedFormBuilder,
    public documentService: DocumentsService,
    public snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<AddDocumentComponent>,
    private fileService: FileService
  ) { }

  ngOnInit() {
    this.GetDocumentType();
    this.initForm();
  }

  private initForm() {
    this.NewDocumentFormGroup = this.fb.group({
      'DocumentType': ['', Validators.required],
      'Description': [''],
      'Document': ['', Validators.required],
      'Date': ['', null],
      'EmployeeId': [''],
      'Type': ['']
    });
    this.NewDocumentFormGroup.get('Date').patchValue(moment());
  }

  private GetDocumentType() {
    this.documentService.getEmployeeDocumentType()
      .pipe(map(resp => {
        return resp.result.sort().map(element => {
          return { value: element.type, viewValue: element.type };
        });
      }))
      .subscribe(result => {
        result.sort(function (a: { value: string, viewValue: string }, b: { value: string, viewValue: string }) {
          return a.viewValue.localeCompare(b.viewValue);
        });
        this.documentTypes = result;
      }, err => {
        console.error(err);
      });
  }

  public AddDocument() {
    this.NewDocumentFormGroup.get('Document').markAsTouched();
    if (this.NewDocumentFormGroup.valid) {
      const fileType = this.NewDocumentFormGroup.get('Type').value;
        //if (!this.allowableFileTypes.includes(fileType)) {
        if (!FileFormatEnum.TrabajadorControllerDocumentoTS.includes(fileType)) {
            this.ShowSnackBar("Formato de fichero no permitido", "", 2500)
            return;
      }

      this.IsSaving = true;
      this.NewDocumentFormGroup.get('Document').markAsTouched();
      this.NewDocumentFormGroup.get('EmployeeId').patchValue(Number(localStorage.getItem("EmplooyeeID")));
      const dateString = (this.NewDocumentFormGroup.get('Date').value !== null) ? DateHelper.getUTCDateString(DateHelper.getNativeDate(this.NewDocumentFormGroup.get('Date').value)) : null;
      this.NewDocumentFormGroup.get('Date').patchValue(dateString);
      if (this.NewDocumentFormGroup.valid) {
        const model = this.NewDocumentFormGroup.value;
        model.Document = this.fileBase64Value;
        this.documentService.saveNewDocument(model)
          .subscribe(resp => {
            if (resp.code === 0) {
              this.IsSaving = false;
              this.ShowSnackBar("Guardado con éxito", "", 2500)
              this.documentService.PublishDocuments(Number(localStorage.getItem("EmplooyeeID")));
              this.dialogRef.close();
            }
          }, err => {
            this.IsSaving = false;
            console.error(err);
          });
      }
    }
  }

  public Cancel() {
    this.dialogRef.close();
  }


  uploadFile(event) {
    this.file = event[0].name;
    this.readFile(event[0]);
  }

  deleteAttachment() {
    this.file = undefined;
    this.NewDocumentFormGroup.get("Document").patchValue(null);
  }

  private readFile(file) {
    let currentContext = this;
    let fileReader = new FileReader();
    fileReader.onload = function (event) {
      currentContext.file = file.name;
      currentContext.fileBase64Value = currentContext.fileService.arrayBufferToBase64(fileReader.result);
      currentContext.NewDocumentFormGroup.get('Type').patchValue(currentContext.fileService.getFileExtention(file.type));
    }
      //if (currentContext.allowableFileTypes.includes(currentContext.fileService.getFileExtention(file.type))) { 
      //10/10/2023 (Documento del trabajador) probando a modificar esta linea para que coja el enum correspondiente. FALTA PROBAR ESTO MAÑANA
    if (FileFormatEnum.TrabajadorControllerDocumentoTS.toString().includes(currentContext.fileService.getFileExtention(file.type))) {
      fileReader.readAsArrayBuffer(file);
      this.NewDocumentFormGroup.get('Document').markAsTouched();
    }
    else {
      currentContext.ShowSnackBar('No se puede aceptar este tipo de archivo', 'Okay', 1500);
    }
  }


  public ShowSnackBar(message: string, action: string, duration: number) {
    return this.snackBar.open(message, action, {
      duration: duration
    });
  }


}
